
// 给 actions 注册事件处理函数，当这个函数被触发时，将状态提交 commit到 mutaions中处理

// export const changeResturantId = ({ commit }) => commit('changeResturantId')
// export const appleDecrement = ({ commit }) => commit('appleDecrement')

// export const bananaIncrement = ({ commit }) => commit('bananaIncrement')
// // export const bananaDecrement = ({ commit }) => commit('bananaDecrement')

export function changeResturantId({ commit }, resturantId) {    // 门店ID
  return commit('changeResturantId', resturantId)
}
export function changeResturantName({ commit }, resturantName) {  // 门店名称
  return commit('changeResturantName', resturantName)
}
export function updataStatisticalDate({ commit }) {  // 营业日期
  return commit('updataStatisticalDate')
}
export function resetStore({ commit }) {  // 营业日期
  return commit('resetStore')
}



// WEBPACK FOOTER //
// ./src/store/actions.js